<p-steps [model]="items" [(activeIndex)]="activeIndex" styleClass="steps-custom"></p-steps>


